import { Swiper } from 'swiper/react'
import styled from '@emotion/styled'

import { minHeight } from './index'

const CustomizeStyledSwiper = styled(Swiper)`
  ${({ theme }) => `
  .swiper-slide {
    width: 100%;
  }

  .banner-swiper-prev, .banner-swiper-next {
    position: absolute;
    display: none;
    background: rgba(256, 256, 256, 0.5);
    box-shadow: 0 0 0.5rem 0.5rem rgba(0, 0, 0, 0.01);
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;

    ${theme.breakpoints.up('lg')} {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
    }

    > .MuiSvgIcon-root {
      font-size: 1rem;
    }
  }
  .banner-swiper-prev {
    left: 24px;
    padding-left: 8px;
  }
  .banner-swiper-next {
    right: 24px;
    padding-left: 2px;
  }

  .banner-pagination {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    bottom: 16px;
    z-index: 1;

    > .swiper-pagination-bullet {
      display: block;
      width: ${theme.spacing(1)};
      height: ${theme.spacing(1)};
      border-radius: 50%;
      background-color: ${theme.palette.text.disabled};
      cursor: pointer;

      &.swiper-pagination-bullet-active {
        width: ${theme.spacing(4)};
        border-radius: 2px;
        background-color: ${theme.palette.primary.mainPlus2};
        opacity: 1;
      }

      &:not(:first-child) {
        margin-left: ${theme.spacing(2)};
      }
    }
  }
`}
`

const ArticlePageStyledSwiper = styled(CustomizeStyledSwiper)`
  .banner-swiper-prev,
  .banner-swiper-next {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
`

const StyledSwiper = styled(CustomizeStyledSwiper)`
  ${({ theme }) => `
    &.swiper {
      min-height: ${minHeight};
    }

    .banner-swiper-prev, .banner-swiper-next {
      position: absolute;
      bottom: 50%;
      transform: translate(0, -50%);
    }

    .banner-pagination {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      position: absolute;
      bottom: 16px;
      z-index: 1;

      ${theme.breakpoints.up('lg')} {
        display: none;
      }
    }
  }
`}
`

const ModuleStyledSwiper = styled(CustomizeStyledSwiper)`
  ${({ theme }) => `
    &.swiper {
      min-height: ${minHeight};
    }

    .banner-swiper-prev, .banner-swiper-next {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }

    .banner-pagination {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      position: absolute;
      bottom: 16px;
      z-index: 1;

      ${theme.breakpoints.up('lg')} {
        display: none;
      }
    }
  }
`}
`

export { minHeight, StyledSwiper, ArticlePageStyledSwiper, ModuleStyledSwiper }
